module.exports = __webpack_public_path__ + "img/photo-0028.7da33559.jpg";